export default "__VITE_ASSET__9wNTkj7S__"